{
  "show_fraud_detected_message_modal": {
    "title": "Posible fraude detectado",
    "body": "El mensaje que has recibido posiblemente sea un mensaje de phishing, ¿quieres verlo de todos modos?"
  },
  "whatsapp_business_api_agent_page": {
    "template_langs": {
      "af": "Afrikáans",
      "sq": "Albanés",
      "ar": "Árabe",
      "az": "Azerbaiyano",
      "bn": "Bengalí",
      "bg": "Búlgaro",
      "ca": "Catalán",
      "zh_CN": "Chino (CHN)",
      "zh_HK": "Chino (HKG)",
      "zh_TW": "Chino (TAI)",
      "hr": "Croata",
      "cs": "Checo",
      "da": "Danés",
      "nl": "Neerlandés",
      "en": "Inglés",
      "en_GB": "Inglés (UK)",
      "en_US": "Inglés (EE. UU.)",
      "et": "Estonio",
      "fil": "Filipino",
      "fi": "Finlandés",
      "fr": "Francés",
      "ka": "Georgiano",
      "de": "Alemán",
      "el": "Griego",
      "gu": "Gujarati",
      "ha": "Hausa",
      "he": "Hebreo",
      "hi": "Hindi",
      "hu": "Húngaro",
      "id": "Indonesio",
      "ga": "Irlandés",
      "it": "Italiano",
      "ja": "Japonés",
      "kn": "Canarés",
      "kk": "Kazajo",
      "rw_RW": "Kinyarwanda",
      "ko": "Coreano",
      "ky_KG": "Kirguís (Kirguistán)",
      "lo": "Lao",
      "lv": "Letón",
      "lt": "Lituano",
      "mk": "Macedonio",
      "ms": "Malayo",
      "ml": "Malayalam",
      "mr": "Marathi",
      "nb": "Noruego",
      "fa": "Persa",
      "pl": "Polaco",
      "pt_BR": "Portugués (BR)",
      "pt_PT": "Portugués (POR)",
      "pa": "Panyabí",
      "ro": "Rumano",
      "ru": "Ruso",
      "sr": "Serbio",
      "sk": "Eslovaco",
      "sl": "Esloveno",
      "es": "Español",
      "es_AR": "Español (ARG)",
      "es_ES": "Español (ESP)",
      "es_MX": "Español (MEX)",
      "sw": "Suajili",
      "sv": "Sueco",
      "ta": "Tamil",
      "te": "Telugu",
      "th": "Tailandés",
      "tr": "Turco",
      "uk": "Ucraniano",
      "ur": "Urdu",
      "uz": "Uzbeko",
      "as": "Asamés",
      "hne": "Chhattisgarhi",
      "km": "Jemer",
      "mni_Mtei": "Meiteilon (Manipuri)",
      "or": "Odia",
      "ps": "Pastún",
      "so": "Somalí",
      "vi": "Vietnamita",
      "yo": "Yoruba",
      "zu": "Zulú"
    },
    "upload_types": {
      "documents": "Documentos",
      "photos_and_videos": "Fotos y Vídeos",
      "camera": "Cámara",
      "location": "Ubicación"
    },
    "drop_files": "Suelta archivos",
    "file_exeeds_limit": "Error al cargar el archivo: {{fileName}}. El tamaño del archivo excede el límite{{maxFileSize}}",
    "no_preview_available": "Vista previa no disponible",
    "chats_filters_title": "FILTRAR CHATS",
    "phone": "Teléfono",
    "first_name": "Nombre",
    "last_name": "Apellido",
    "save": "Guardar",
    "failed_to_start_new_chat": "Error al iniciar un nuevo chat. Por favor, inténtelo de nuevo.",
    "failed_to_add_contact": "Error al agregar contacto. Por favor, inténtelo de nuevo.",
    "failed_to_add_contact_phone_number_already_exists": "No se pudo agregar el contacto: El número de teléfono proporcionado ya existe en nuestros registros. Por favor, verifique el número ingresado con precisión o considere actualizar los detalles de contacto existentes.",
    "failed_to_add_contact_to_contacts": "Error al agregar chat al contacto. Por favor, inténtelo de nuevo.",
    "failed_to_update_contact": "Error al actualizar contacto. Por favor, inténtelo de nuevo.",
    "failed_to_update_contact_phone_number_already_exists": "No se pudo actualizar el contacto: El número de teléfono que ingresó ya existe en nuestros registros. Por favor, asegúrese de que el número de teléfono sea único o considere editar el contacto existente.",
    "failed_to_archive_contact": "Error al archivar contacto. Por favor, inténtelo de nuevo.",
    "failed_to_archive_chat": "Error al archivar chat. Por favor, inténtelo de nuevo.",
    "failed_to_unarchive_contact": "Error al desarchivar contacto. Por favor, inténtelo de nuevo.",
    "failed_to_unarchive_chat": "Error al desarchivar chat. Por favor, inténtelo de nuevo.",
    "failed_to_send_message": "Error al enviar mensaje. Por favor, inténtelo de nuevo.",
    "empty_state_message": "Comience a chatear instantáneamente haciendo clic en cualquier chat",
    "contacts_empty_state_message": "Selecciona un contacto para comenzar a gestionar tu lista de contactos",
    "nav_options": {
      "chats": "Chats",
      "active_chats": "Chats activos",
      "archived": "Chats archivados",
      "unknown": "Chats desconocidos",
      "contacts": "Contactos",
      "campaigns": "Campañas"
    },
    "send_templates_to_many": {
      "sendingTemplates": "Enviando Plantillas...",
      "failedToSendTemplates": "Error al enviar plantillas",
      "templatesSent": "Plantillas Enviadas",
      "failedToSendToChats": "Plantillas Enviadas\nError al enviar a - {{numberOfFailed}} clientes"
    },
    "bulk_send": {
      "title": "Envío Masivo de Mensajes",
      "step_1_upload": "Cargar Números de Teléfono",
      "step_1_template": "Paso 1: Seleccionar Plantilla",
      "step_2_phone": "Paso 2: Seleccionar Teléfono Remitente",
      "step_2_options": "Opciones",
      "step_3_select_phone": "Seleccionar Teléfono",
      "step_3_csv": "Paso 3: Cargar CSV",
      "step_4_template": "Seleccionar Plantilla",
      "step_4_media": "Paso 4: Cargar Encabezado {{type}}",
      "instructions": "Carga un archivo CSV con números de teléfono para enviar mensajes.",
      "download_template": "Descargar Plantilla CSV",
      "drop_csv": "Arrastra el archivo CSV aquí o haz clic para navegar",
      "drop_media": "Arrastra el archivo {{type}} aquí o haz clic para navegar",
      "phone_number": "Número de Teléfono",
      "first_name": "Nombre",
      "last_name": "Apellido",
      "preview": "Vista previa (mostrando las primeras 5 filas)",
      "add_to_contacts": "Agregar números de teléfono a Contactos",
      "select_phone": "Selecciona un número de teléfono para enviar desde",
      "select_template": "Selecciona una plantilla para enviar",
      "send_messages": "Enviar Mensajes",
      "create_campaign": "Crear Campaña",
      "no_whatsapp_phones": "No hay teléfonos de WhatsApp disponibles. Por favor, configura un teléfono de WhatsApp primero.",
      "sending_messages": "Enviando mensajes...",
      "all_messages_sent": "¡Todos los {{count}} mensajes se enviaron exitosamente!",
      "all_messages_failed": "Error al enviar todos los mensajes",
      "partial_success": "{{successCount}} mensajes enviados, {{failedCount}} fallaron",
      "send_failed": "Error al enviar mensajes. Por favor, inténtalo de nuevo.",
      "csv_errors": {
        "empty_file": "El archivo CSV está vacío",
        "missing_required_headers": "El archivo CSV carece de encabezados requeridos: {{missingRequiredHeaders}}",
        "invalid_headers": "El archivo CSV contiene encabezados inválidos: {{invalidHeaders}}",
        "invalid_phones": "El archivo CSV contiene números de teléfono inválidos: {{invalidPhones}}",
        "too_many_rows": "El archivo CSV contiene {{rowCount}} filas, pero el máximo permitido es {{maxRows}} filas",
        "missing_template_params": "El archivo CSV carece de columnas de parámetros de plantilla: {{params}}"
      },
      "cancel": "Cancelar",
      "required": "Requerido",
      "optional": "Opcional",
      "phone_description": "Todos los números de teléfono válidos recibirán mensajes",
      "first_name_description": "Usado para la creación de contactos",
      "last_name_description": "Usado para la creación de contactos",
      "contact_note": "Nota: Solo las entradas con Nombre y Apellido serán agregadas como contactos cuando \"Agregar a contactos\" esté habilitado.",
      "contacts_to_add": "{{count}} contactos serán agregados",
      "campaign_name": "Nombre de la Campaña",
      "campaign_name_placeholder": "Ingresa un nombre para esta campaña",
      "media_type_mismatch": "Por favor sube un archivo {{expected}}",
      "summary": "Resumen",
      "summary_rows": "{{count}} destinatarios",
      "summary_template": "Plantilla: {{name}}",
      "summary_phone": "Desde: {{phone}}",
      "campaign_created": "¡Campaña creada!",
      "campaign_error": "Error al crear la campaña"
    },
    "campaigns": {
      "title": "Campañas",
      "loading": "Cargando campañas...",
      "loading_items": "Cargando elementos...",
      "no_campaigns": "Aún no hay campañas. Crea una campaña de envío masivo para comenzar.",
      "no_items": "No se encontraron elementos",
      "no_search_results": "No se encontraron campañas que coincidan con tu búsqueda",
      "search_placeholder": "Buscar campañas...",
      "select_campaign": "Selecciona una campaña para ver los detalles",
      "back_to_list": "Volver a campañas",
      "back": "Volver",
      "total": "Total",
      "success": "Éxito",
      "failed": "Fallido",
      "pending": "Pendiente",
      "all": "Todos",
      "phone": "Teléfono",
      "first_name": "Nombre",
      "last_name": "Apellido",
      "status": "Estado",
      "error": "Error",
      "export": "Exportar",
      "template": "Plantilla",
      "sender": "Remitente",
      "created": "Creado",
      "add_campaign_tooltip": "Agregar campaña"
    },
    "labels": {
      "add_labels": "Añadir etiquetas",
      "select_contacts_to_add_labels": "Seleccionar contactos para añadir etiquetas",
      "modal": {
        "header": "Seleccionar etiquetas",
        "failed_to_add_labels_to_selected_chats": "Error al añadir etiquetas a los chats seleccionados",
        "succeed_to_add_labels_to_selected_chats": "Etiquetas añadidas a los chats seleccionados correctamente"
      }
    },
    "filters": {
      "all": "Todos",
      "unassigned": "Sin asignar",
      "assigned_to_me": "Asignados a mí"
    },
    "status": {
      "label": "Estado",
      "open": "Abierto",
      "pending": "Pendiente",
      "bot": "Bot",
      "closed": "Cerrado",
      "update_success": "Estado actualizado correctamente",
      "update_failed": "Error al actualizar el estado"
    },
    "assign_agent": {
      "placeholder": "Asignar agente...",
      "no_agents": "No hay agentes disponibles",
      "search_placeholder": "Buscar agentes...",
      "assigned": "Asignado",
      "update_success": "Asignación de agente actualizada",
      "update_failed": "Error al actualizar la asignación de agente"
    },
    "opt_in": {
      "send": {
        "message1": "Has iniciado una solicitud de aceptación con el contacto.",
        "message2": "Una vez que el contacto acepte, podrás comenzar a enviar mensajes."
      },
      "no_send": {
        "message1": "Aún no has iniciado una solicitud de aceptación con el contacto.",
        "message2": "Si quieres enviar el template de aceptación, haz clic",
        "here": "aquí"
      },
      "modal": {
        "message1": "Esta acción requiere la aprobación del contacto para iniciar la comunicación a través de WhatsApp.",
        "message2": "¿Estás seguro de que quieres enviar la solicitud de aceptación?",
        "template_name": "Nombre de la template:",
        "template_lang": "Idioma de la template:",
        "header": "Iniciar Aceptación del Cliente",
        "send_template_header": "Seleccionar template para enviar",
        "param_required": "Este campo es obligatorio",
        "param_too_long": "Máximo {{max}} caracteres permitidos",
        "enter_param_value": "Ingrese valor para {{{{index}}}}",
        "assign_conversation_to_me": "Asignar conversación a mí",
        "set_conversations_status_to_open": "Establecer estado de conversación en abierto",
        "image_header": "Encabezado de Imagen",
        "video_header": "Encabezado de Video",
        "document_header": "Encabezado de Documento",
        "upload_image": "Subir imagen:",
        "upload_video": "Subir video:",
        "upload_document": "Subir documento:",
        "drop_or_click": "Arrastra y suelta o haz clic para subir",
        "file_too_large": "El tamaño del archivo excede el límite ({{maxSize}})",
        "invalid_file_type": "Tipo de archivo inválido. Esperado {{expected}}",
        "file_required": "Por favor, sube un archivo para el encabezado de medios"
      }
    },
    "add_contact_modal": {
      "add_contact_title": "Agregar contacto",
      "edit_contact_title": "Editar contacto"
    },
    "chat_list": {
      "header": "Chats",
      "add_chat_tooltip": "Seleccionar contacto",
      "search_contact_placeholder": "Buscar...",
      "no_search_results": "No se encontraron chats",
      "no_contacts": "Haz clic en la opción '+' para seleccionar o agregar un contacto y comenzar a chatear",
      "select_contact_to_send_template": "Seleccionar contactos para enviar la template",
      "cancel_select_contact_to_send_template": "Cancelar selección de contactos",
      "add_contact_via_csv": "Añadir contacto a través de CSV"
    },
    "select_contact_modal": {
      "title": "Seleccionar contacto",
      "search_placeholder": "Buscar contacto",
      "no_contact": "Para comenzar a chatear, haz clic en la opción '+' para agregar un contacto.",
      "no_results": "No encontramos nada",
      "chat_from": "Chatear desde {{number}}"
    },
    "contact_list": {
      "header": "Chats",
      "add_contact_tooltip": "Agregar contacto",
      "search_contact_placeholder": "Buscar...",
      "no_search_results": "No se encontraron contactos",
      "no_contacts": "Haz clic en la opción '+' para agregar contacto"
    },
    "message_panel": {
      "text_placeholder": "Escribe un mensaje"
    },
    "configuration_missing_message1": "Configuración incompleta de WhatsApp Business API",
    "configuration_missing_message2": "Por favor, contacta a tu administrador para completar la configuración",
    "smarters_token_missing_message1": "El token de Smarters no está configurado",
    "smarters_token_missing_message2": "Por favor, contacta a tu administrador para configurar el token de Smarters para tu teléfono de WhatsApp Business API",
    "archive_contact": {
      "message1": "¿Estás seguro de que quieres archivar el contacto '{{name}}'?",
      "message1_multiple": "¿Está seguro de que desea archivar {{num_of_items}} contactos?",
      "message2": "Archivar eliminará el contacto de tu lista activa. Sin embargo, se conservará tu historial de chat pasado.",
      "archive": "Archivar",
      "unarchive": "Desarchivar",
      "unarchive_message": "¿Estás seguro de que quieres desarquivar el contacto '{{name}}'?",
      "title": "Archivar contacto"
    },
    "archive_chat": {
      "message1": "¿Estás seguro de que quieres archivar el chat '{{name}}'?",
      "message1_multiple": "¿Está seguro de que desea archivar {{num_of_items}} chats?",
      "message2": "Archivar eliminará el chat de tu lista activa. Sin embargo, se conservará tu historial de chat pasado.",
      "archive": "Archivar",
      "unarchive": "Desarchivar",
      "unarchive_message": "¿Estás seguro de que quieres desarquivar el chat '{{name}}'?",
      "unarchive_message_multiple": "¿Está seguro de que desea desarchivar {{num_of_items}} chats?",
      "title": "Archivar chat"
    },
    "add_to_contacts": "Agregar a contactos",
    "contact_details": "Detalles del contacto",
    "convert_unknown_contact": "Marcar contacto como conocido",
    "convert_unknown_contact_modal_message": "¿Estás seguro de que quieres marcar '{{name}}' como conocido?",
    "create_new_contact": "Crear nuevo contacto",
    "add_to_existing_contact": "Agregar a contacto existente",
    "chat_from_dialog": {
      "title": "Seleccione el canal para chatear"
    },
    "selected_chats": "Chats seleccionados",
    "send_template": "Enviar template",
    "send_location_permissions_decline": "Es necesario otorgar permisos de ubicación para enviar la ubicación",
    "failed_to_import_contacts_from_csv": "Error al importar contactos desde el archivo CSV",
    "contacts_imported_successfully": "Contactos importados correctamente"
  },
  "no_results": "Sin resultados",
  "waba_errors": {
    "title": "Error en la Entrega del Mensaje",
    "unknown": "Este mensaje no pudo ser entregado.",
    "generic_error": "Su mensaje no pudo ser entregado (Error {{errorCode}}).",
    "media_download_error": "El tipo de archivo no es compatible. Por favor, intente con un formato diferente.",
    "media_file_size_too_big": "El tamaño del archivo excede el límite. Por favor, intente con un archivo más pequeño.",
    "media_type_not_supported": "El tipo de medio no es compatible con este tipo de mensaje.",
    "media_download_failed": "Error al descargar el archivo multimedia. Por favor, inténtelo de nuevo.",
    "rate_limit_hit": "El mensaje no fue entregado debido a límites de tasa. Por favor, inténtelo más tarde.",
    "message_limit_exceeded": "Ha excedido el límite de mensajes para este número de teléfono.",
    "business_restricted": "La empresa tiene restricciones para enviar mensajes.",
    "template_param_count_mismatch": "El número de parámetros de la plantilla no coincide con la plantilla.",
    "template_not_found": "La plantilla no existe o no ha sido aprobada.",
    "template_content_mismatch": "El contenido de la plantilla no coincide con la plantilla aprobada.",
    "template_paused": "La plantilla fue pausada debido a una calificación de baja calidad.",
    "template_disabled": "La plantilla está deshabilitada.",
    "template_params_invalid": "Los parámetros de la plantilla faltan o son inválidos.",
    "template_quality_low": "La calidad de la plantilla es demasiado baja para enviar.",
    "invalid_recipient": "El destinatario no es un usuario válido de WhatsApp.",
    "recipient_not_in_allowed_list": "Este número de teléfono no está en la lista permitida de su cuenta de WhatsApp.",
    "user_not_opted_in": "Este mensaje no pudo ser entregado porque el cliente no ha dado su consentimiento.",
    "outside_24h_window": "El mensaje no se pudo enviar porque fue enviado fuera de la ventana de 24 horas.",
    "cloud_api_rate_limit": "Se alcanzó el límite de la API de WhatsApp Cloud. Por favor, inténtelo más tarde.",
    "internal_error": "Algo salió mal en los servidores de WhatsApp. Por favor, inténtelo de nuevo.",
    "access_denied": "Acceso denegado. Por favor, verifique los permisos.",
    "account_locked": "La cuenta comercial está bloqueada o restringida.",
    "message_too_old": "El mensaje no se pudo enviar. El mensaje puede ser demasiado antiguo.",
    "message_type_not_supported": "El tipo de mensaje no es compatible.",
    "recipient_blocked": "El destinatario bloqueó los mensajes de esta empresa.",
    "required_parameter_missing": "Falta un parámetro obligatorio en la solicitud.",
    "parameter_value_invalid": "Un valor de parámetro no es válido.",
    "phone_number_not_registered": "El número de teléfono no está registrado para WhatsApp Business.",
    "unsupported_message": "Este tipo de mensaje no es compatible.",
    "display_name_approval_required": "Se requiere la aprobación del nombre para mostrar antes de enviar mensajes.",
    "temporarily_unavailable": "WhatsApp no está disponible temporalmente. Por favor, inténtelo más tarde.",
    "user_experiment": "Este mensaje no pudo enviarse debido a una restricción de experimento de usuario.",
    "phone_number_reverification_needed": "Se requiere la reverificación del número de teléfono.",
    "pair_rate_limit": "Se enviaron demasiados mensajes a este destinatario en poco tiempo. Por favor, espere antes de intentarlo de nuevo.",
    "healthy_ecosystem_engagement": "Meta no entregó este mensaje para mantener un ecosistema saludable: el destinatario recibió demasiados mensajes de marketing recientemente. Por favor, inténtelo más tarde.",
    "media_upload_failed": "Error al subir el archivo multimedia. Puede estar dañado, no ser compatible o ser demasiado grande.",
    "template_text_too_long": "El mensaje de la plantilla es demasiado largo después de completar los parámetros.",
    "template_content_policy": "El contenido de la plantilla infringe la política de formato o caracteres de WhatsApp.",
    "recipient_same_as_sender": "El número de teléfono del destinatario no puede ser el mismo que el del remitente.",
    "payment_issue": "Hay un problema de pago con la cuenta de WhatsApp Business. Por favor, revise la configuración de facturación.",
    "incorrect_certificate": "El certificado de registro del número de teléfono falta o es incorrecto. Por favor, vuelva a registrar el número.",
    "account_maintenance": "La cuenta de WhatsApp Business está en modo de mantenimiento. Por favor, inténtelo más tarde."
  },
  "resend_message": {
    "message_not_synced": "El mensaje aún no se ha sincronizado, inténtalo de nuevo en unos minutos",
    "message_file_not_found": "No pudimos encontrar el archivo del mensaje, intenta escribir un nuevo mensaje con el mismo archivo y texto",
    "cannot_send_empty_text": "No se puede enviar un mensaje de texto sin texto",
    "resend_message": "Reenviar mensaje",
    "confirm_resend_message": "¿Estás seguro de que quieres reenviar este mensaje?",
    "cannot_resend_message": "Tuvis no pudo reenviar el mensaje, por favor inténtalo de nuevo más tarde",
    "message_resent": "El mensaje ha sido reenviado"
  }
}
